import { useState } from "react";
import { BrandMark } from "./BrandMark";

interface PrivateMatchScreenProps {
  onBack: () => void;
  onCreate: () => void;
  onJoin: (code: string) => void;
}

export function PrivateMatchScreen({ onBack, onCreate, onJoin }: PrivateMatchScreenProps) {
  const [tab, setTab] = useState<"create" | "join">("create");
  const [code, setCode] = useState("");

  return (
    <main className="centered-screen">
      <button className="back-button" type="button" onClick={onBack}>← Back</button>
      <BrandMark compact />
      <section className="dialog-card private-card" aria-labelledby="private-title">
        <p className="eyebrow"><span /> Play with a friend</p>
        <h1 id="private-title">Private match</h1>
        <p>Create a short-lived room or enter the code shared by a host.</p>

        <div className="segmented-control" role="tablist" aria-label="Private match action">
          <button type="button" role="tab" aria-selected={tab === "create"} onClick={() => setTab("create")}>Create</button>
          <button type="button" role="tab" aria-selected={tab === "join"} onClick={() => setTab("join")}>Join</button>
        </div>

        {tab === "create" ? (
          <div className="private-action-panel" role="tabpanel">
            <div className="room-illustration" aria-hidden="true"><span>1</span><i /><span>2</span></div>
            <h2>Host the table</h2>
            <p>You will get a room code to share. The match starts only when both players connect and are ready.</p>
            <button className="primary-button" type="button" onClick={onCreate}>Create private room <span>→</span></button>
          </div>
        ) : (
          <form
            className="private-action-panel"
            role="tabpanel"
            onSubmit={(event) => {
              event.preventDefault();
              if (code.trim()) onJoin(code);
            }}
          >
            <label className="code-field">
              <span>Room code</span>
              <input
                value={code}
                onChange={(event) => setCode(event.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, "").slice(0, 24))}
                placeholder="M123456789ABCDEFG"
                maxLength={24}
                autoCapitalize="characters"
                autoComplete="off"
                spellCheck={false}
                autoFocus
              />
            </label>
            <p>The server checks the code and issues your own temporary connection ticket.</p>
            <button className="primary-button" type="submit" disabled={!code.trim()}>Join room <span>→</span></button>
          </form>
        )}
      </section>
    </main>
  );
}
